import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

// ProtectedRoute wraps the AppShell route group so any page inside it
// requires a logged-in user. If no session, redirect to /login while
// preserving the target URL in `?next=` so the login flow can send the
// user back where they wanted after success.
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { currentUser } = useAuth();
  const location = useLocation();
  if (!currentUser) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <>{children}</>;
}
